import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect } from 'react-router-dom'
import qs from 'query-string'

import { passwordReset } from '../../api'

import { Logo, Button } from '../Common'
import Form from './Form'

import style from './ChangePassword.scss'

class ChangePassword extends Component {
  static propTypes = {
    search: PropTypes.object,
  }

  state = {
    loading: false,
    redirect: false,
    token: undefined,
  }

  UNSAFE_componentWillMount() {
    const { token } = this.props.search
    this.setState((state) => ({
      ...state,
      token,
    }))
  }

  handleSubmit = ({ password, passwordConfirm }) => {
    if (this.state.loading) return
    this.setState(
      (state) => ({
        ...state,
        loading: true,
      }),
      () => {
        const token = this.state.token
        passwordReset(token, password, passwordConfirm).then(() => {
          this.setState((state) => ({
            ...state,
            redirect: true,
          }))
        })
      },
    )
  }

  render() {
    const { loading, email, redirect } = this.state
    if (redirect) {
      return <Redirect to={{ pathname: '/login', search: qs.stringify({ email }) }} />
    }
    return (
      <div className={style.wrapper}>
        <Logo id="logo" className={style.logo} />
        <Link id="link-login" to="/login" className={style.link}>
          <Button theme="white" className={style.button} xl id="button-voltar">
            voltar
          </Button>
        </Link>
        <Form id="form-trocar-senha" loading={loading} onSubmit={this.handleSubmit} />
      </div>
    )
  }
}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js